import { Box, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoginForm from "./LoginForm";
import Navigation from "../../../common/navigation/Navigation";
import { useAlertNotification } from "../../../common/hooks/useAlertNotification";

const LoginPage = () => {
    const [searchParams] = useSearchParams();
    const reauthenticate = !!searchParams.get('reauthenticate');
    const { setAlert } = useAlertNotification();

    const navigate = useNavigate();

    const onLogin = async (evt) => {
        const redirectUrl = (sessionStorage.getItem('redirectAfterLogin')) || '/admin/';
        sessionStorage.removeItem('redirectAfterLogin');

        navigate(redirectUrl);
    }

    const onError = (error) => {
        setAlert({
            message: error.message,
            severity: 'error'
        });
    }

    return <>
        <Navigation />
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
            {reauthenticate && <Typography variant="h6" sx={{ marginBottom: '20px' }}>Your session has expired</Typography>}
            <LoginForm onSuccess={onLogin} onError={onError} />
        </Box>
    </>
}

export default LoginPage;